export const pattern12Data = [
  {
    id: 1,
    koreanChunks: [
      "직원",
      "그... ",
      "(현재)일하는",
      "IT 부서에서",
      "(현재)사임했다",
    ],
    englishChunks: [
      "The employee",
      "who ",
      "works",
      " in the IT department",
      "has resigned",
    ],
    fullEnglish: "The employee who works in the IT department has resigned.",
    explanation:
      "주격 관계대명사 'who'가 사용된 문장입니다. 'who'는 사람을 선행사로 하는 주격 관계대명사입니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "직원",
      "그.. ",
      "(과거에)받은",
      "최고의 성과 평가를 ",
      "(미래에)승진될 것이다",
      "다음 달에",
    ],
    englishChunks: [
      "The employee",
      "who",
      " received",
      "the highest performance rating",
      "will be promoted",
      " next month",
    ],
    fullEnglish:
      "The employee who received the highest performance rating will be promoted next month.",
    explanation:
      "주격 관계대명사 'who'가 사용된 문장입니다. 'who'는 사람을 선행사로 하는 주격 관계대명사이며, 'the employee'를 수식합니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "새로운 매니저는",
      "그... ",
      "이전에(과거에) 근무했던",
      "글로벌 기업에서 ",
      "(과거에)도입했다 여러 가지 변화를 ",
    ],
    englishChunks: [
      "The new manager",
      "who",
      "previously worked",
      "at a global company",
      "introduced several changes",
    ],
    fullEnglish:
      "The new manager, who previously worked at a global company, introduced several changes.",
    explanation:
      "주격 관계대명사 'who'가 사용된 문장입니다. 여기서는 부가적인 정보를 제공하는 관계대명사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "제안서",
      "그.. ",
      "(과거에) 검토된 이사회에서",
      "(과거에)승인됬다 만장일치로 ",
    ],
    englishChunks: [
      "The proposal",
      "which",
      "was reviewed by the board",
      "was approved unanimously",
    ],
    fullEnglish:
      "The proposal, which was reviewed by the board, was approved unanimously.",
    explanation:
      "주격 관계대명사 'which'가 사용된 문장입니다. 여기서는 부가적인 정보를 제공하는 관계대명사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "우리는 (현재) 출시했다",
      " 새로운 소프트웨어를",
      "그..",
      " 향상시키는",
      "데이터 보안을",
    ],
    englishChunks: [
      "We have launched",
      " a new software",
      "which",
      "improves",
      "data security",
    ],
    fullEnglish:
      "We have launched a new software, which improves data security.",
    explanation:
      "주격 관계대명사 'which'가 사용된 문장입니다. 사물을 선행사로 하며, 부가적인 정보를 제공하는 관계대명사절입니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "회사",
      "그...",
      "(현재)제공하는",
      "최고의 고객 서비스를",

      "(미래에)받을 것이다 그 상을",
    ],
    englishChunks: [
      "The company",
      "that",
      " provides",
      "the best customer service",
      "will receive the award",
    ],
    fullEnglish:
      "The company that provides the best customer service will receive the award.",
    explanation:
      "주격 관계대명사 'that'이 사용된 문장입니다. 여기서는 'the company'를 수식하는 제한적 관계대명사절로 사용되었습니다.",
  },
  {
    id: 7,
    koreanChunks: ["책", "그..", "네가 (과거에)추천했던", "매우 유익했다"],
    englishChunks: [
      "The book",
      "that",
      " you recommended",
      "was very informative",
    ],
    fullEnglish: "The book that you recommended was very informative.",
    explanation:
      "목적격 관계대명사 'that'이 사용된 문장입니다. 'the book'을 수식하며, 'you recommended'의 목적어 역할을 합니다.",
  },
  {
    id: 8,
    koreanChunks: ["이곳이 사무실이다", "그..", "회의가 열릴 예정인"],
    englishChunks: [
      "This is the office",
      "where",
      "the conference will be held",
    ],
    fullEnglish: "This is the office where the conference will be held.",
    explanation:
      "관계부사 'where'가 사용된 문장입니다. 장소를 나타내는 선행사 'office'를 수식합니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "카페",
      "그..",
      "우리가 만났던 지난주에 ",
      "(현재) 가진다",
      "훌륭한 커피를",
    ],
    englishChunks: [
      "The café",
      "where",
      " we met last week",
      "has",
      "excellent coffee",
    ],
    fullEnglish: "The café where we met last week has excellent coffee.",
    explanation:
      "관계부사 'where'가 사용된 문장입니다. 장소를 나타내는 선행사 'café'를 수식합니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "(과거에) 시간이 있었다 ",
      "그.. ",
      "사람들이 타자기를 사용했던",
      "컴퓨터 대신",
    ],
    englishChunks: [
      "There was a time",
      "when",
      "people used typewriters",
      "instead of computers",
    ],
    fullEnglish:
      "There was a time when people used typewriters instead of computers.",
    explanation:
      "관계부사 'when'이 사용된 문장입니다. 시간을 나타내는 선행사 'time'을 수식합니다.",
  },
  {
    id: 11,
    koreanChunks: ["월요일은 날이다", "그..", "새로운 정책이 시행되는"],
    englishChunks: ["Monday is the day", "when", "the new policy takes effect"],
    fullEnglish: "Monday is the day when the new policy takes effect.",
    explanation:
      "관계부사 'when'이 사용된 문장입니다. 시간을 나타내는 선행사 'day'를 수식합니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "후보자는",
      "그..",
      "우리가 인터뷰했던 어제",
      "매우 유능하다",
    ],
    englishChunks: [
      "The candidate",
      "whom",
      "we interviewed yesterday",
      "is highly qualified",
    ],
    fullEnglish:
      "The candidate whom we interviewed yesterday is highly qualified.",
    explanation:
      "관계대명사 'whom'이 사용된 문장입니다. 사람을 나타내는 선행사 'candidate'를 수식합니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "제품",
      "그..",
      "우리회사가 최근에 출시한",
      "잘 팔리고 있다",
    ],
    englishChunks: [
      "The product",
      "that",
      "our company recently launched",
      "is selling well",
    ],
    fullEnglish:
      "The product that our company recently launched is selling well.",
    explanation:
      "관계대명사 'that'이 사용된 문장입니다. 사물을 나타내는 선행사 'product'를 수식합니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "보고서가",
      "그..",
      "매니저가 (과거에) 요청한",
      "(현재) 완료되었다",
    ],
    englishChunks: [
      "The report",
      "which",
      " the manager requested",
      "has been completed",
    ],
    fullEnglish: "The report which the manager requested has been completed.",
    explanation:
      "관계대명사 'which'가 사용된 문장입니다. 사물을 나타내는 선행사 'report'를 수식합니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "직원이",
      "그.. ",
      "제안이 (과거에) 승인된",
      "받았다 보너스를 ",
    ],
    englishChunks: [
      "The employee",
      "whose",
      "proposal was accepted",
      "received a bonus",
    ],
    fullEnglish: "The employee whose proposal was accepted received a bonus.",
    explanation:
      "관계대명사 'whose'가 사용된 문장입니다. 소유격 관계대명사로 선행사 'employee'의 소유물인 'proposal'을 수식합니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "과학자가",
      "그.. ",
      "연구가 산업을 변화시킨",
      "(과거에)받았다 상을",
    ],
    englishChunks: [
      "The scientist",
      "whose",
      " research changed the industry",
      "was awarded a prize",
    ],
    fullEnglish:
      "The scientist whose research changed the industry was awarded a prize.",
    explanation:
      "관계대명사 'whose'가 사용된 문장입니다. 소유격 관계대명사로 선행사 'scientist'의 소유물인 'research'를 수식합니다.",
  },
  {
    id: 17,
    koreanChunks: [
      "회사가",
      "그.. ",
      " 본사가 뉴욕에 있는",
      "확장하고 있다 국제적으로 ",
    ],
    englishChunks: [
      "The company",
      "whose",
      "headquarters are in New York",
      "is expanding internationally",
    ],
    fullEnglish:
      "The company whose headquarters are in New York is expanding internationally.",
    explanation:
      "관계대명사 'whose'가 사용된 문장입니다. 소유격 관계대명사로 선행사 'company'의 소유물인 'headquarters'를 수식합니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "회의가 열릴 것이다.",
      "장소에서",
      "그..",
      "최신 기술이 전시되는",
    ],
    englishChunks: [
      "The conference will be held",
      "at a venue",
      "where",
      "the latest technology is showcased",
    ],
    fullEnglish:
      "The conference will be held at a venue where the latest technology is showcased.",
    explanation:
      "관계부사 'where'가 사용된 문장입니다. 장소를 나타내는 선행사 'venue'를 수식합니다.",
  },
  {
    id: 19,
    koreanChunks: ["월요일은 날이다", "그..", "모든 보고서를 제출해야 하는"],
    englishChunks: [
      "Monday is the day",
      "when",
      "all reports must be submitted",
    ],
    fullEnglish: "Monday is the day when all reports must be submitted.",
    explanation:
      "관계부사 'when'이 사용된 문장입니다. 시간을 나타내는 선행사 'day'를 수식합니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "컨설턴트는",
      "그..",
      "회사가 고용한",
      "전문으로 한다 국제 무역을 ",
    ],
    englishChunks: [
      "The consultant",
      "whom",
      "the company hired",
      "specializes in international trade",
    ],
    fullEnglish:
      "The consultant whom the company hired specializes in international trade.",
    explanation:
      "목적격 관계대명사 'whom'이 사용된 문장입니다. 선행사 'consultant'가 관계절에서 목적어 역할을 합니다.",
  },
  {
    id: 21,
    koreanChunks: [
      "공급업체가",
      "그..",
      "우리 구매팀이 선정한",
      "최적의 가격을 제시했다",
    ],
    englishChunks: [
      "The vendor",
      "whom",
      "our purchasing team selected",
      "offered the best price",
    ],
    fullEnglish:
      "The vendor whom our purchasing team selected offered the best price.",
    explanation:
      "목적격 관계대명사 'whom'이 사용된 문장입니다. 선행사 'vendor'가 관계절에서 목적어 역할을 합니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "후보자들은",
      "그..",
      "인사부가 면접 본",
      "받을 것이다",
      "최종 결정을 ",
      "다음 주에",
    ],
    englishChunks: [
      "The candidates",
      "whom",
      "the HR department interviewed",
      "will receive",
      "the final decision",
      "next week",
    ],
    fullEnglish:
      "The candidates whom the HR department interviewed will receive the final decision next week.",
    explanation:
      "목적격 관계대명사 'whom'이 사용된 문장입니다. 선행사 'candidates'가 관계절에서 목적어 역할을 합니다.",
  },
  {
    id: 23,
    koreanChunks: [
      "마케팅 이사는",
      "그..",
      "20년 이상의 경력을 가진",
      "이끌 예정이다",
      "새로운 프로젝트를",
    ],
    englishChunks: [
      "The marketing director",
      "who",
      "has over 20 years of experience",
      "will lead",
      "the new project",
    ],
    fullEnglish:
      "The marketing director, who has over 20 years of experience, will lead the new project.",
    explanation:
      "주격 관계대명사 'who'가 사용된 문장입니다. 부가적인 정보를 제공하는 관계대명사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 24,
    koreanChunks: [
      "최신 보고서는",
      "그..",
      "발표된 오늘 아침에",
      "보여준다",
      "크게 증가했음을 매출이 ",
    ],
    englishChunks: [
      "The latest report",
      "which",
      "was released this morning",
      "shows",
      "a significant increase in sales",
    ],
    fullEnglish:
      "The latest report, which was released this morning, shows a significant increase in sales.",
    explanation:
      "주격 관계대명사 'which'가 사용된 문장입니다. 부가적인 정보를 제공하는 관계대명사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 25,
    koreanChunks: [
      "우리의 새로운 사무실은",
      "그..",
      "시내에 위치한",
      "개장할 것이다",
      "다음 달에",
    ],
    englishChunks: [
      "Our new office",
      "which",
      "is located downtown",
      "will open",
      "next month",
    ],
    fullEnglish:
      "Our new office, which is located downtown, will open next month.",
    explanation:
      "주격 관계대명사 'which'가 사용된 문장입니다. 부가적인 정보를 제공하는 관계대명사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 26,
    koreanChunks: [
      "존슨 씨가",
      "그..",
      "내가 만났던 회의에서",
      "제안했다",
      "나에게 일자리를",
    ],
    englishChunks: [
      "Mr. Johnson",
      "whom",
      "I met at the conference",
      "offered",
      "me a job opportunity",
    ],
    fullEnglish:
      "Mr. Johnson, whom I met at the conference, offered me a job opportunity.",
    explanation:
      "목적격 관계대명사 'whom'이 사용된 문장입니다. 부가적인 정보를 제공하는 관계대명사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "연례 회사 회의가",
      "그..",
      "중요한 정책이 논의되는",
      "예정되어 있다",
      "다음 주 월요일로",
    ],
    englishChunks: [
      "The annual company meeting",
      "where",
      "important policies are discussed",
      "is scheduled",
      "for next Monday",
    ],
    fullEnglish:
      "The annual company meeting, where important policies are discussed, is scheduled for next Monday.",
    explanation:
      "관계부사 'where'가 사용된 문장입니다. 부가적인 정보를 제공하는 관계부사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "CEO의 결정이",
      "그..",
      "놀라게 했던 많은 직원들을",
      "발표되었다",
      "어제",
    ],
    englishChunks: [
      "The CEO's decision",
      "which",
      "surprised many employees",
      "was announced",
      "yesterday",
    ],
    fullEnglish:
      "The CEO's decision, which surprised many employees, was announced yesterday.",
    explanation:
      "주격 관계대명사 'which'가 사용된 문장입니다. 부가적인 정보를 제공하는 관계대명사절로 쉼표와 함께 사용되었습니다.",
  },
  {
    id: 29,
    koreanChunks: [
      "회사는",
      "그..",
      "내가 근무하는",
      "확장 중이다",
      "회사의 사업을 해외로",
    ],
    englishChunks: [
      "The company",
      "for which",
      "I work",
      "is expanding",
      "its operations overseas",
    ],
    fullEnglish:
      "The company for which I work is expanding its operations overseas.",
    explanation:
      "전치사 + 관계대명사 'for which'가 사용된 문장입니다. 선행사 'company'를 수식하는 관계대명사절에서 전치사가 관계대명사 앞에 위치합니다.",
  },
  {
    id: 30,
    koreanChunks: [
      "회의가",
      "그..",
      "새로운 정책이 발표됬던",
      "지속됬다",
      "3시간 동안",
    ],
    englishChunks: [
      "The conference",
      "during which",
      "the new policy was introduced",
      "lasted",
      "for three hours",
    ],
    fullEnglish:
      "The conference during which the new policy was introduced lasted for three hours.",
    explanation:
      "전치사 + 관계대명사 'during which'가 사용된 문장입니다. 시간을 나타내는 전치사와 함께 관계대명사가 사용되었습니다.",
  },
  {
    id: 31,
    koreanChunks: [
      "컨설턴트는",
      "그...",
      "우리가 논의했던 프로젝트에 대해",
      "제공했다",
      "귀중한 인사이트를",
    ],
    englishChunks: [
      "The consultant",
      "with whom",
      "we discussed the project",
      "provided",
      "valuable insights",
    ],
    fullEnglish:
      "The consultant with whom we discussed the project provided valuable insights.",
    explanation:
      "전치사 + 관계대명사 'with whom'이 사용된 문장입니다. 사람을 가리키는 'whom'이 전치사와 함께 사용되었습니다.",
  },
  {
    id: 32,
    koreanChunks: [
      "지침은",
      "그.. ",
      "모든 직원이 반드시 따라야하는",
      "명확하게 명시되있다",
      "메뉴얼에",
    ],
    englishChunks: [
      "The guidelines",
      "under which",
      "all employees must operate",
      "are clearly stated",
      "in the manual",
    ],
    fullEnglish:
      "The guidelines under which all employees must operate are clearly stated in the manual.",
    explanation:
      "전치사 + 관계대명사 'under which'가 사용된 문장입니다. 규칙이나 조건을 나타내는 맥락에서 전치사와 관계대명사가 함께 사용되었습니다.",
  },
  {
    id: 33,
    koreanChunks: [
      "마감일은",
      "그...",
      "모든보고서들이 반드시 제출되어야 하는",
      "금요일이다",
    ],
    englishChunks: [
      "The deadline",
      "by which",
      "all reports must be submitted",
      "is Friday",
    ],
    fullEnglish:
      "The deadline by which all reports must be submitted is Friday.",
    explanation:
      "전치사 + 관계대명사 'by which'가 사용된 문장입니다. 시간의 기한을 나타내는 맥락에서 전치사와 관계대명사가 함께 사용되었습니다.",
  },
  {
    id: 34,
    koreanChunks: [
      "그것이 이유다",
      "그...",
      "회사가 결정한",
      "절감하기로 비용을",
    ],
    englishChunks: [
      "That is the reason",
      "why",
      "the company decided",
      "to reduce costs",
    ],
    fullEnglish: "That is the reason why the company decided to reduce costs.",
    explanation:
      "관계부사 'why'가 사용된 문장입니다. 'reason'과 함께 사용되어 이유를 설명하는 절을 이끕니다.",
  },
  {
    id: 35,
    koreanChunks: ["나는 모른다", "왜", "회의가", "연기되었는지"],
    englishChunks: ["I don't know", "why", "the meeting", "was postponed"],
    fullEnglish: "I don't know why the meeting was postponed.",
    explanation:
      "관계부사 'why'가 의문절을 이끄는 문장입니다. 'know' 뒤에서 이유를 묻는 간접의문문을 형성합니다.",
  },
  {
    id: 36,
    koreanChunks: ["매니저는 설명했다", "왜", "새 정책이", "필요한지"],
    englishChunks: [
      "The manager",
      "explained",
      "why",
      "the new policy",
      "is necessary",
    ],
    fullEnglish: "The manager explained why the new policy is necessary.",
    explanation:
      "관계부사 'why'가 'explain' 뒤에서 이유를 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 37,
    koreanChunks: [
      "아무도 이해하지 못한다",
      "왜",
      "고객이 갑자기 취소했는지",
      "계약을",
    ],
    englishChunks: [
      "Nobody understands",
      "why",
      "the client suddenly canceled",
      "the contract",
    ],
    fullEnglish:
      "Nobody understands why the client suddenly canceled the contract.",
    explanation:
      "관계부사 'why'가 'understand' 뒤에서 이유를 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 38,
    koreanChunks: [
      "그 보고서는",
      "못했다",
      "설명하는것을",
      "왜",
      "매출이 감소했는지",
      "지난 분기에",
    ],
    englishChunks: [
      "The report",
      "failed",
      "to clarify",
      "why",
      "the sales declined",
      "last quarter",
    ],
    fullEnglish:
      "The report failed to clarify why the sales declined last quarter.",
    explanation:
      "관계부사 'why'가 'clarify' 뒤에서 이유를 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 39,
    koreanChunks: [
      "나는 절대 잊지 않을 것이다",
      "그 순간을",
      "그..",
      "내가 받았던",
      "첫번째 일자리 제안을",
    ],
    englishChunks: [
      "I will never forget",
      "the moment",
      "when",
      "I received",
      "my first job offer",
    ],
    fullEnglish:
      "I will never forget the moment when I received my first job offer.",
    explanation:
      "관계부사 'when'이 시간을 나타내는 명사 'moment' 뒤에서 시점을 구체적으로 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 40,
    koreanChunks: [
      "마감일은",
      "다음 주 금요일이다",
      "그...",
      "모든 보고서가 반드시 제출되어야 하는",
    ],
    englishChunks: [
      "The deadline",
      "is next Friday",
      "when",
      "all reports must be submitted",
    ],
    fullEnglish:
      "The deadline is next Friday, when all reports must be submitted.",
    explanation:
      "관계부사 'when'이 시간을 나타내는 표현 'next Friday' 뒤에서 그 시점에 일어날 일을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 41,
    koreanChunks: [
      "그 회사는",
      "설립되었다",
      "1995년에 ",
      "그...",
      "기술 산업이",
      "급격히 성장중이었던",
    ],
    englishChunks: [
      "The company",
      "was founded",
      "in 1995",
      "when",
      "the technology industry",
      "was rapidly growing",
    ],
    fullEnglish:
      "The company was founded in 1995, when the technology industry was rapidly growing.",
    explanation:
      "관계부사 'when'이 시간을 나타내는 표현 '1995' 뒤에서 당시의 상황을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 42,
    koreanChunks: [
      "회의는",
      "열릴 것이다 다음 주 월요일에 ",
      "그..",
      "CEO가",
      "중요한 발표를 할 예정인",
    ],
    englishChunks: [
      "The meeting",
      "will take place next Monday",
      "when",
      "the CEO",
      "will make an important announcement",
    ],
    fullEnglish:
      "The meeting will take place next Monday, when the CEO will make an important announcement.",
    explanation:
      "관계부사 'when'이 시간을 나타내는 표현 'next Monday' 뒤에서 그 시점에 일어날 일을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 43,
    koreanChunks: [
      "때가 있었다",
      "그...",
      "사람들이 종이 지도를 사용했던",
      "GPS 대신",
    ],
    englishChunks: [
      "There was a time",
      "when",
      "people relied on paper maps",
      "instead of GPS",
    ],
    fullEnglish:
      "There was a time when people relied on paper maps instead of GPS.",
    explanation:
      "관계부사 'when'이 시간을 나타내는 명사 'time' 뒤에서 과거의 상황을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 44,
    koreanChunks: ["여기가 사무실이다", "그...", "중요한 결정이", "내려지는"],
    englishChunks: [
      "This is the office",
      "where",
      "important decisions",
      "are made",
    ],
    fullEnglish: "This is the office where important decisions are made.",
    explanation:
      "관계부사 'where'가 장소를 나타내는 명사 'office' 뒤에서 그 장소에서 일어나는 일을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 45,
    koreanChunks: [
      "호텔은",
      "그....",
      "세미나가 열렸었던",
      "받았다",
      "좋은 평가를 ",
    ],
    englishChunks: [
      "The hotel",
      "where",
      "the seminar was held",
      "received",
      "great reviews",
    ],
    fullEnglish: "The hotel where the seminar was held received great reviews.",
    explanation:
      "관계부사 'where'가 장소를 나타내는 명사 'hotel' 뒤에서 그 장소에서 일어난 일을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 46,
    koreanChunks: [
      "반납해 주세요 장비를",
      "창고로",
      "그...",
      "그것이 원래 보관되었던",
    ],
    englishChunks: [
      "Please return the equipment",
      "to the storage room",
      "where",
      "it was originally kept",
    ],
    fullEnglish:
      "Please return the equipment to the storage room where it was originally kept.",
    explanation:
      "관계부사 'where'가 장소를 나타내는 명사구 'storage room' 뒤에서 그 장소의 원래 용도를 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 47,
    koreanChunks: [
      "레스토랑은",
      "그...",
      "우리가 점심을 먹었던 어제",

      "매우 붐볐다",
    ],
    englishChunks: [
      "The restaurant",
      "where",
      "we had lunch yesterday",
      "was very crowded",
    ],
    fullEnglish:
      "The restaurant where we had lunch yesterday was very crowded.",
    explanation:
      "관계부사 'where'가 장소를 나타내는 명사 'restaurant' 뒤에서 그 장소에서 일어난 과거의 일을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 48,
    koreanChunks: [
      "회사가",
      "그...",
      "내가 예전에 근무했던",

      "지금 확장중이다 유럽으로",
    ],
    englishChunks: [
      "The company",
      "where",
      " I used to work",
      "is now expanding into Europe",
    ],
    fullEnglish:
      "The company where I used to work is now expanding into Europe.",
    explanation:
      "관계부사 'where'가 장소를 나타내는 명사 'company' 뒤에서 화자의 과거 경험을 설명하는 절을 이끄는 문장입니다.",
  },
  {
    id: 49,
    koreanChunks: [
      "나는 또한 계획한다 위임하는 것을",
      "책임을 내 팀에게,",
      "보장하면서",
      "그... 없다는 것을 방해가",
      "진행 중인 프로젝트에",
      "내가 자리를 비우는 동안",
    ],
    englishChunks: [
      "I also plan to delegate",
      "responsibilities to my team,",
      "ensuring",
      "that there is no disruption",
      "in ongoing projects",
      "while I am away",
    ],
    fullEnglish:
      "I also plan to delegate responsibilities to my team, ensuring that there is no disruption in ongoing projects while I am away.",
    explanation:
      "현재분사구문 'ensuring'은 '보장하면서'라는 의미로 주절의 동작과 동시에 일어나는 상황이나 목적을 표현합니다. 이 분사구문은 주절의 동작(위임)이 어떤 결과나 목적을 가지고 있는지 설명합니다.",
    additionalExplanation:
      "더 설명하는 내용도 '그..'를 붙여서 어디에 붙어서 설명하는지 쉽게 알고, 영어 어순을 변경하지 않도록 합니다.",
  },

  {
    id: 50,
    koreanChunks: [
      "회사는 찾고 있는 중이다",
      "개인들을",
      "그...보유한 강한 의사소통 능력을",
    ],
    englishChunks: [
      "The company is seeking",
      "individuals",
      "possessing strong communication skills",
    ],
    fullEnglish:
      "The company is seeking individuals possessing strong communication skills.",
    explanation:
      "현재분사구문 'possessing'은 '보유한'이라는 의미로 명사(individuals)를 수식하는 분사구로 사용되었습니다. 이는 어떤 종류의 개인을 찾고 있는지 구체적으로 설명합니다.",
    additionalExplanation:
      "수식하는 현재분사, 과거분사의 경우 그..를 넣으면 해석이 쉽습니다.",
  },
  {
    id: 51,
    koreanChunks: [
      "직원들 그.. 재택근무중인",
      "로그인해야 합니다",
      "시스템에",
      "오전 9시까지",
    ],
    englishChunks: [
      "Employees working remotely",
      "must log in",
      "to the system",
      "by 9 a.m.",
    ],
    fullEnglish:
      "Employees working remotely must log in to the system by 9 a.m.",
    explanation:
      "현재분사구문 'working'은 '일하는'이라는 의미로 명사(Employees)를 수식하는 분사형용사로 사용되었습니다. 이는 어떤 직원들에 대한 규칙인지 구체적으로 설명합니다.",
    additionalExplanation:
      "수식하는 현재분사, 과거분사의 경우 그..를 넣으면 해석이 쉽습니다.",
  },
  {
    id: 52,
    koreanChunks: ["매니저 그.. 검토 중인 재무 보고서를", "요청했다", "설명을"],
    englishChunks: [
      "The manager reviewing the financial report",
      "asked for",
      "clarification",
    ],
    fullEnglish:
      "The manager reviewing the financial report asked for clarification.",
    explanation:
      "현재분사구문 'reviewing'은 '검토 중인'이라는 의미로 명사(manager)를 수식하는 분사형용사로 사용되었습니다. 이는 어떤 매니저인지 구체적으로 설명합니다.",
    additionalExplanation:
      "수식하는 현재분사, 과거분사의 경우 그..를 넣으면 해석이 쉽습니다.",
  },
  {
    id: 53,
    koreanChunks: [
      "팀 그.. 준비 중인 출시를",

      "늦게까지 남아 있었다",
      "사무실에",
    ],
    englishChunks: [
      "A team preparing for the product launch",
      "stayed late",
      "at the office",
    ],
    fullEnglish:
      "A team preparing for the product launch stayed late at the office.",
    explanation:
      "현재분사구문 'preparing'은 '준비 중인'이라는 의미로 명사(team)를 수식하는 분사형용사로 사용되었습니다. 이는 어떤 팀인지 구체적으로 설명합니다.",
    additionalExplanation:
      "수식하는 현재분사, 과거분사의 경우 그..를 넣으면 해석이 쉽습니다.",
  },
  {
    id: 54,
    koreanChunks: [
      "문서 그.. 포함된 개인 정보가",
      "다뤄져야 한다",
      "주의 깊게",
    ],
    englishChunks: [
      "The document containing personal data",
      "must be handled",
      "carefully",
    ],
    fullEnglish:
      "The document containing personal data must be handled carefully.",
    explanation:
      "현재분사구문 'containing'은 '포함된'이라는 의미로 명사(document)를 수식하는 분사형용사로 사용되었습니다. 이는 어떤 문서인지 구체적으로 설명합니다.",
    additionalExplanation:
      "수식하는 현재분사, 과거분사의 경우 그..를 넣으면 해석이 쉽습니다.",
  },
  {
    id: 55,
    koreanChunks: [
      "내 이름은 John Ballard이고,",
      "그리고 나는 전문 프리랜서이다",
      "그...전문으로 하는",
      "콘텐츠 제작, 디자인 및 디지털 마케팅을",
    ],
    englishChunks: [
      "My name is John Ballard,",
      "and I am a professional freelancer",
      "specializing",
      "in content creation, design, and digital marketing",
    ],
    fullEnglish:
      "My name is John Ballard, and I am a professional freelancer specializing in content creation, design, and digital marketing.",
    explanation:
      "현재분사구문 'specializing'은 '전문으로 하는'이라는 의미로 명사구(a professional freelancer)를 수식하는 분사형용사로 사용되었습니다. 이는 어떤 종류의 프리랜서인지 구체적으로 설명합니다.",
    additionalExplanation: "",
  },
  {
    id: 56,
    koreanChunks: [
      "나는 확신한다",
      "그.. 내가 자산이 될 것이라는 것",
      "그리고 기여할 것이라는 것을 긍정적으로 ",
      "당신의 재능있는 팀에",
    ],
    englishChunks: [
      "I am confident",
      "that I will be an asset",
      "and contribute positively",
      "to your talented team",
    ],
    fullEnglish:
      "I am confident that I will be an asset and contribute positively to your talented team.",
    explanation:
      "이 문장은 'that'으로 시작하는 명사절을 포함하고 있습니다. 'that I will be an asset and contribute positively'는 'confident'의 내용을 설명하는 명사절로 사용되었습니다.",
    additionalExplanation:
      "보충, 수식은 계속 그...를 넣어서 문장구조를 헷갈려하지 않고 영어어순대로 읽도록 합니다.",
  },
  {
    id: 57,
    koreanChunks: [
      "저는 문의하고 싶습니다",
      "만약 귀사가 필요로 하는지 프리랜서를",
      "그...효율적으로 이행할 수 있는 이러한 약속들을",
    ],
    englishChunks: [
      "I would like to inquire",
      "if your company needs a freelancer",
      " who can efficiently deliver these commitments",
    ],
    fullEnglish:
      "I would like to inquire if your company needs a freelancer who can efficiently deliver these commitments.",
    explanation:
      "이 문장은 'who'로 시작하는 관계절을 포함하고 있습니다. 'who can efficiently deliver these commitments'는 'a freelancer'를 수식하는 관계절로 사용되었습니다.",
    additionalExplanation: "",
  },
];
